/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from "react";
import Sidebar from "components/molecules/Sidebar";
import MapView from "components/molecules/MapView";
import ResultsList from "components/molecules/ResultsList";
import "styles/landing-page.scss";
import { useSelector } from "react-redux";
import Modal from "components/atoms/Modal";
import ASRDetailsContent from "components/molecules/ASRDetails";
import { useDispatch } from "react-redux";
import * as SearchSlice from "store/slice/search.slice";
import type { RootState } from "store";
import useIsDesktop from "hooks/useIsDesktop";
import "simplebar-react/dist/simplebar.min.css";
import { apim } from "services/auth.service";
import * as Icons from 'constants/icons';

const LandingPage: FC = () => {
  const isDesktop = useIsDesktop();
  const { selectedRow, isSearchBtnClicked } = useSelector((state: RootState) => state.search);
  const dispatch = useDispatch();

  const asrConfigData = async () => {
    try{
      const {data}:{data:any} = await apim.get(
        `${process.env.REACT_APP_APIM_HOST}/asr/data/filter`,{
          headers: {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
          }
        }
      );
      if (data) {
        dispatch(SearchSlice.setConfigs({
          radius: data.configs?.radius.map((ele: string) => `${ele} miles`),
          categories: [
            { id: "all", name: "All" },
            ...data.categories
          ],
          required_expertises: data.required_expertise,
          time: data.configs?.repair_time,
        }));
      }
    } catch(err:any) {
      console.error(err.message)
    }
  };

  useEffect(() => {
    if (!isDesktop || isSearchBtnClicked) {
      dispatch(SearchSlice.setShowDrawer(true));
    } else { dispatch(SearchSlice.setShowDrawer(false)) }
  }, [isDesktop]);

  useEffect(() => {
    asrConfigData()
  }, []);

  return (
    <>
      <header>
        <img src={Icons.logo} alt="ASR Finder" />
      </header>
      <div className="asr-landing-page">
        {isDesktop && (
          <div className="left">
            <aside className="asr-sidebar">
              <Sidebar isDesktop={isDesktop} />
            </aside>
          </div>
        )}
        {Object.keys(selectedRow).length > 0 && <Modal><ASRDetailsContent /></Modal>}
        <div className="right">
          <MapView />
          <ResultsList isDesktop={isDesktop} />
        </div>
      </div>
    </>
  );
};

export default LandingPage;
